import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ResidentialPickup } from './pages/ResidentialPickup';
import { BudgetBagService } from './pages/BudgetBagService';
import { CommercialDumpsters } from './pages/CommercialDumpsters';
import { ConstructionHauling } from './pages/ConstructionHauling';
import { BulkItemPickup } from './pages/BulkItemPickup';
import { TemporaryDumpsters } from './pages/TemporaryDumpsters';
export function AppRouter() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/services/residential-pickup" element={<ResidentialPickup data-id="element-15" />} data-id="element-14" />
        <Route path="/services/budget-bag" element={<BudgetBagService data-id="element-17" />} data-id="element-16" />
        <Route path="/services/commercial-dumpsters" element={<CommercialDumpsters data-id="element-19" />} data-id="element-18" />
        <Route path="/services/construction-hauling" element={<ConstructionHauling data-id="element-21" />} data-id="element-20" />
        <Route path="/services/bulk-item-pickup" element={<BulkItemPickup data-id="element-23" />} data-id="element-22" />
        <Route path="/services/temporary-dumpsters" element={<TemporaryDumpsters data-id="element-25" />} data-id="element-24" />
      </Routes>
    </BrowserRouter>;
}